// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rank-box[data-v-eefd4314]{padding:0 .3rem}", ""]);
// Exports
module.exports = exports;
